import React, { useRef } from "react";

export default function OTPInput({ value, onChange, length = 5, disabled = false, variant = "default" }) {
  const inputRefs = useRef([]);

  const handleKeyDown = (e, idx) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    if (
      !/^[0-9]{1}$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }

    if ((e.key === "Delete" || e.key === "Backspace") && !value[idx]) {
      if (idx > 0) {
        inputRefs.current[idx - 1]?.focus();
      }
    }
  };

  const handleInput = (e, idx) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    if (!val) return;
    const newOtp = value.split("");
    newOtp[idx] = val.slice(-1);
    onChange(newOtp.join(""));
    if (idx < length - 1) {
      inputRefs.current[idx + 1]?.focus();
    }
  };

  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = value.split("");
    newOtp[idx] = val.slice(-1);
    onChange(newOtp.join(""));
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  const applyPastedDigits = (rawDigits) => {
    if (!rawDigits.length) return;
    const chunk = rawDigits.slice(0, length);
    onChange(chunk);
    const focusIdx = Math.min(Math.max(chunk.length - 1, 0), length - 1);
    requestAnimationFrame(() => {
      const el = inputRefs.current[focusIdx];
      el?.focus();
      el?.select?.();
    });
  };

  const handlePaste = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const text = e.clipboardData.getData("text").replace(/[^0-9]/g, "");
    applyPastedDigits(text);
  };

  const boxClass =
    variant === "glass"
      ? "w-10 h-11 sm:w-12 sm:h-12 rounded-lg border border-zinc-400/50 bg-white/90 text-center text-lg font-semibold shadow-inner outline-none transition selection:bg-zinc-300/60 focus:border-primaryBlue focus:ring-2 focus:ring-primaryBlue/35 disabled:opacity-50 sm:text-xl"
      : "w-8 h-8 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-md md:rounded-lg border border-gray-300 bg-white text-center text-base sm:text-2xl font-bold text-blue-900 shadow focus:ring-2 focus:ring-blue-400 outline-none transition-all duration-150 mx-1";

  const glassTextStyle =
    variant === "glass"
      ? {
          color: "black",
          WebkitTextFillColor: "black",
          caretColor: "#2563eb",
        }
      : undefined;

  return (
    <div className="flex flex-wrap justify-center gap-2 sm:gap-2.5">
      {Array.from({ length }).map((_, idx) => (
        <input
          key={idx}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete={idx === 0 ? "one-time-code" : "off"}
          maxLength={1}
          value={value[idx] || ""}
          onChange={(e) => handleChange(e, idx)}
          onInput={(e) => handleInput(e, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          onFocus={handleFocus}
          onPaste={handlePaste}
          ref={(el) => {
            inputRefs.current[idx] = el;
          }}
          disabled={disabled}
          className={boxClass}
          style={glassTextStyle}
        />
      ))}
    </div>
  );
}
